<ng-container *ngIf="assetService.selectedAsset">
  <div class="d-flex">
    <div *ngIf="assetService.selectedAsset?.id" class="d-block w-50 mr-3">
      <div class="d-flex justify-content-between mb-2">
        <h4>{{ 'lang.globals.files'|translate }}</h4>
        <div class="d-flex">
          <button (click)="togglePreview()" class="btn btn-outline-success mr-1">
            <sb-icon icon="plus" *ngIf="showPreview" class="mr-1"></sb-icon>
            <sb-icon icon="photos" *ngIf="!showPreview" class="mr-1"></sb-icon>
            {{ showPreview ? ('lang.globals.newFile'|translate) : ('lang.globals.preview'|translate) }}
          </button>
          <button class="btn btn-default" (click)="assetService.refreshSelectedAsset()">
            <sb-icon icon="refresh"></sb-icon>
          </button>
        </div>
      </div>
      <div *ngIf="!showPreview">
        <sb-comp-uploading-element>
        </sb-comp-uploading-element>
        <div style="height: 150px">
          <sb-comp-file-upload [uploadType]="'asset'" [parent]="assetService.selectedAsset"></sb-comp-file-upload>
        </div>
        <div class="d-flex justify-content-center my-2">
          {{ 'lang.globals.or' |translate }}
        </div>
        <form [formGroup]="form" class="p-2" style="border: 2px dashed #92b0b3; border-radius: 6px">
          <div class="w-100">
            <div class="form-group validateMe d-block">
              <label class="form-label" for="Link">{{ 'lang.globals.link' | translate }}</label>
              <div class="d-flex position-relative">
                <input class="form-control flex-grow-1 mr-2" formControlName="Link" id="Link" type="text">
                <button class="btn btn-default mr-2" (click)="pasteDataFromClipboard('link')">
                  <sb-icon class="cursor-pointer" icon="paste"></sb-icon>
                </button>
              </div>
              <span class="form-text text-muted">{{ 'lang.globals.urlDescription' | translate }}</span>
              <div *ngIf="Link.touched && Link.errors?.required" class="alert alert-danger">
                {{ 'lang.globals.notEmpty' | translate }}
              </div>
              <div *ngIf="Link.touched && Link.errors?.pattern" class="alert alert-danger">
                {{ 'lang.globals.wrongUrlPattern' | translate }}
              </div>
            </div>

            <div class="form-group validateMe d-block">
              <label class="form-label" for="Thumbnail">{{ 'lang.globals.preview' | translate }}</label>
              <div class="d-flex position-relative">
                <input class="form-control flex-grow-1 mr-2" formControlName="Thumbnail" id="Thumbnail" type="text">
                <button class="btn btn-default mr-2" (click)="pasteDataFromClipboard('thumbnail')">
                  <sb-icon class="cursor-pointer" icon="paste"></sb-icon>
                </button>
              </div>
              <span class="form-text text-muted">{{ 'lang.globals.urlDescription' | translate }}</span>
              <p *ngIf="Thumbnail.touched && Thumbnail.errors?.pattern" class="alert alert-danger">
                {{ 'lang.globals.wrongUrlPattern' | translate }}
              </p>
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <button class="btn btn-default" (click)="addLink()" [disabled]="!form.valid">
              <sb-icon class="cursor-pointer" icon="link"></sb-icon>
              {{ 'lang.globals.addLink'|translate }}
            </button>
          </div>
        </form>
      </div>
      <div *ngIf="showPreview">
        <div class="position-relative w-100">

          <div style="background-size: cover; display: flex; height: 310px; width: 100%; align-items: center;
  justify-content: center; background-repeat: no-repeat;background-position: center center"
               [style.backgroundImage]=" assetService.selectedAsset?.preview?.thumbnailLink ? 'url(' + assetService.selectedAsset?.preview?.thumbnailLink + ')'
                  : assetService.selectedAsset?.preview?.link ? 'url('+assetService.selectedAsset?.preview?.link+')' :'url(./../assets/img/no-image.png)' ">
            <!--
            <div class="d-flex position-absolute" style="top: 15px; right:15px">
              <button *ngIf="asset?.id" class="btn btn-danger" [ngbTooltip]="'lang.globals.deleteAsset' | translate"
                      container="body"
                      (click)="deleteClick.emit(true)">
                <sb-icon icon="trash"></sb-icon>
              </button>
            </div>
            -->
          </div>
        </div>
      </div>
      <ng-scrollbar style="width: 100%; height: 280px;">
        <div class="mt-2 d-flex justify-content-between" *ngFor="let assetFile of assetService.selectedAsset?.assetFiles">
          <div class="d-flex align-items-center">
            <div class="symbol-label" style="width: 80px; height: 80px"
                 [style.backgroundImage]=" assetFile.thumbnailLink ? 'url(' + assetFile.thumbnailLink + ')'
                  : assetFile.link ? 'url('+assetFile.link+')' :'url(./../assets/img/no-image.png)' ">
            </div>
            <div class="d-flex align-items-center ml-2">
              <div class="d-block">

                <div class="d-flex font-weight-bold"
                     [class.red]="assetService?.duplicateResolutions?.includes(assetFile?.resolution?.id)">
                  <sb-icon icon="resolution" class="mr-1"></sb-icon>
                  {{ assetFile?.resolution?.id }}
                  <sb-icon *ngIf="assetService?.duplicateResolutions?.includes(assetFile?.resolution?.id)"
                           icon="attention" class="ml-1"
                           [ngbTooltip]="'lang.globals.doubleResolution'|translate" container="body"></sb-icon>
                </div>
                <div class="d-flex">
                  <sb-icon icon="file" class="mr-1"></sb-icon>
                  {{ util.formatBytes(assetFile?.size) }}
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex mr-4">
            <button ngbTooltip="{{'lang.mediumGroupEdit.setAsPreview' | translate}}" placement="left"
                    class="btn btn-clean mr-1"
                    (click)="assetService.setToPreview(assetFile)"
                    [ngClass]="{'yellow': assetFile?.id===assetService.selectedAsset?.preview?.id}">
              <sb-icon icon="starFilled"></sb-icon>
            </button>
            <a ngbTooltip="{{'lang.globals.download' | translate}}" placement="left"
               class="btn btn-default mr-1 d-flex align-items-center" [download]="assetFile.name" [href]="assetFile.link" target="_blank">
              <sb-icon icon="download"></sb-icon>
            </a>
            <button class="btn btn-danger" (click)="assetService.deleteAssetFile(assetFile)">
              <sb-icon icon="trash"></sb-icon>
            </button>
          </div>
        </div>
      </ng-scrollbar>
    </div>

    <div class="d-block" [ngClass]="assetService.selectedAsset?.id? 'w-50' : 'w-100'">
      <h4>{{ 'lang.globals.assetInformation'|translate }}</h4>
      <label class="form-label" for="name">{{ 'lang.globals.name' |translate }}</label>
      <input id="name" name="name" class="form-control" [(ngModel)]="assetService.selectedAsset.name"><!-- [disabled]="!editable">-->
      <label class="form-label mt-3" for="description">{{ 'lang.globals.description' |translate }}</label>
      <textarea id="description" name="description" rows="4" class="form-control"
                [(ngModel)]="assetService.selectedAsset.description"></textarea>
      <!--          [disabled]="!editable" for textarea
      <ng-container *ngIf="editable">
      -->
      <label class="form-label mt-3" for="validity">{{ 'lang.globals.validity' |translate }}</label>
      <sb-local-date-range-input id="validity" class="mr-2" [today]="null"
                                 [from]="assetService.selectedAsset?.shareStart"
                                 [till]="assetService.selectedAsset?.shareEnd"
                                 (dateChange)="assetService.handleDateChangeAssets($event)"></sb-local-date-range-input>
      <div class="my-2">{{ 'lang.globals.assetCategory'|translate }}</div>
      <sb-comp-selection [display]="assetService.selectedAsset?.category"
                         (selectClicked)="assetService.selectCategory()"
                         (createClicked)="assetService.createCategory()"
                         (deleteClicked)="assetService.deleteCategory()"></sb-comp-selection>
      <div class="mt-4 d-flex">
        <div class="d-flex align-items-center position-relative tag tag-input mr-1">
          <sb-icon icon="tag"></sb-icon>
          <input (keydown.enter)="assetService.addTag()"
                 [(ngModel)]="assetService.newTag"
                 [placeholder]="'lang.globals.newTag' | translate"
                 class="form-control slideInput"
                 style="width: 70px; font-size: 0.8rem;font-weight: 600;height: 16px;margin: 0;" />
        </div>
        <ng-container *ngIf="assetService.selectedAsset.tags && assetService.selectedAsset.tags.length <= 3">

          <span *ngFor="let tag of assetService.selectedAsset.tags; let first = first" class="tag tag-input mr-1 cursor-pointer">
            <sb-icon (click)="assetService.removeTag(tag)" class="mr-1" icon="cancel" style="font-size: .6rem;"></sb-icon>
            <span [innerHTML]="tag | truncate: 20"></span>
          </span>

        </ng-container>
        <ng-container *ngIf="assetService.selectedAsset.tags && assetService.selectedAsset.tags.length > 3">
          <div class="d-flex">
      <span [ngbPopover]="popContent" autoClose="outside"
            class="tag grey-bg white cursor-pointer" container="body" popoverClass="tag-container">
    <sb-icon class="mr-1" icon="tags"></sb-icon>
        {{ assetService.selectedAsset.tags ? assetService.selectedAsset.tags.length : null }}
  </span>
          </div>
          <ng-template #popContent>
            <div class="d-flex">
      <span *ngFor="let tag of assetService.selectedAsset.tags"
            class="tag mr-1 cursor-pointer tag-input">
        <sb-icon (click)="assetService.removeTag(tag)" class="mr-1"
                 icon="cancel" style="font-size: .6rem;"></sb-icon>
        <span [innerHTML]="tag | truncate: 5"></span>
    </span>
            </div>
          </ng-template>

        </ng-container>
      </div>
      <ng-container *ngIf="assetService.selectedAsset.createdAt">
        <div class="mt-2">{{ 'lang.globals.modifiedAt' | translate }}</div>
        <sb-comp-display-modified [data]="assetService.selectedAsset"></sb-comp-display-modified>
      </ng-container>
    </div>

  </div>
  <div class="d-flex justify-content-between mt-4">
    <button (click)="assetService.resetViewAssets(false)" class="btn btn-default">
      <sb-icon icon="cancel" class="mr-1"></sb-icon>
      {{ 'lang.globals.close'|translate }}
    </button>
    <button (click)="assetService.updateAsset(assetService.selectedAsset)" class="btn btn-primary">
      <sb-icon icon="save"></sb-icon>
      {{ assetService.selectedAsset.id ? ('lang.globals.saveAndClose' |translate) : ('lang.globals.save' |translate) }}
    </button>
  </div>

</ng-container>

